module.exports = __webpack_public_path__ + "static/media/02_before.a4b9b23d.jpg";